export default class DisqualifiersText {

	public version: number | null = null;
	public preambleTexts: string[] = [];
	public conditionTexts: string[] = [];
	public postTexts: string[] = [];

	public constructor() {

	}
};